export function redirectTo(url) {
  window.location.replace(url)
}